import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import sharmiladoc from '../../../../assets/images/Doctorsimages/dr.sharmila.png'
import favicon from "../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const SharmilaDoc = () => {
  const navigate = useNavigate(); 
  
  useEffect(() => {
    document.title = "Dr. Sharmila | Best Dentist in Chennai | H-Cura Multispeciality Clinic";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Sharmila (BDS), a top-rated Consultant Dentist at H-Cura Multispeciality Clinic, Chennai. Specializing in preventive dentistry and holistic oral wellness with 1 year of clinical excellence."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best dentist in Chennai, female dentist in Chennai, preventive dentistry specialist Chennai, H-Cura Multispeciality Clinic Chennai, dental consultation near me, oral health and wellness expert Chennai, general dentist in Chennai, affordable dental care Chennai, best doctor for gum health Chennai, family dentist in Chennai"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-sharmila-bds-preventive-dentist-chennai";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');
    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => { img.style.opacity = '1'; });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        scrollY: -window.scrollY,
        scrollX: -window.scrollX,
        imageTimeout: 0,
        removeContainer: false
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvasWidth;
        const imgWidth = canvasWidth * scaleFactor;
        const imgHeight = canvasHeight * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr.Sharmila_H-Cura_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Sharmila</span>
                  <span className="veenadoc-title-credentials">(B.D.S.)</span>
                  <span className="veenadoc-title-location">Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A highly dedicated <strong>Consultant Dentist at H-Cura Multispeciality Clinic</strong>, Dr. Sharmila is committed to redefining oral healthcare in Chennai. With a year of focused clinical excellence, she blends modern dental innovation with a compassionate, patient-first approach to ensure every smile is healthy, vibrant, and long-lasting.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img 
                        src={sharmiladoc} 
                        alt="Dr. Sharmila – Consultant Dentist at H-Cura Multispeciality Clinic Chennai" 
                        className="veenadoc-doctor-image" 
                        title='Dr. Sharmila | Best Dentist for Preventive Oral Health in Chennai' 
                      />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>Leading the Way in Modern Dental Care</h2>
                  <p>
                    Dr. Sharmila (B.D.S.) is an advocate for holistic oral wellness, currently serving as a key dental professional at <strong>H-Cura Multispeciality Clinic, Chennai</strong>. Her approach is rooted in the belief that a healthy mouth is the gateway to a healthy body. 
                  </p>
                  <p>
                    In her <strong>one year of clinical practice</strong>, she has established herself as a meticulous clinician known for her gentle touch and precise diagnostic skills. Patients seeking a <strong>female dentist in Chennai</strong> find her practice welcoming, modern, and highly effective.
                  </p>
                </div>

                {/* Academic Excellence */}
                <div className="veenadoc-article-block">
                  <h2>Academic Foundation & Clinical Prowess</h2>
                  <p>
                    Dr. Sharmila earned her Bachelor of Dental Surgery (B.D.S.) from the prestigious <strong>Thai Moogambigai Dental College</strong>. Her academic journey was marked by a deep commitment to understanding the complexities of oral-systemic health, which she now applies daily at H-Cura.
                  </p>
                  <p>
                    Her clinical foundation allows her to handle everything from routine preventive care to complex restorative treatments with the highest level of proficiency and hygiene standards.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Professional Highlights</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">B.D.S.</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">1 Year Clinical Excellence</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Clinic:</span>
                      <span className="veenadoc-info-value">H-Cura Multispeciality Clinic</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Chennai</span>
                    </div>
                  </div>
                </div>

                {/* Professional Experience at H-Cura */}
                <div className="veenadoc-article-block">
                  <h2>Excellence at H-Cura Multispeciality Clinic</h2>
                  <p>
                    At <strong>H-Cura Multispeciality Clinic</strong>, Dr. Sharmila brings a fresh, modern perspective to general dentistry. She is recognized for taking the extra time to understand each patient's unique health history and lifestyle. This dedication ensures that every treatment plan is personalized, sustainable, and focused on long-term wellness rather than temporary fixes.
                  </p>
                </div>

                {/* Philosophy */}
                <div className="veenadoc-article-block">
                  <h2>A Holistic Philosophy of Care</h2>
                  <p>
                    What sets Dr. Sharmila apart is her unique treatment philosophy. She believes that oral health education is the most powerful tool for disease prevention. By educating her patients on the link between oral hygiene and overall bodily health, she helps them avoid complex surgical interventions in the future.
                  </p>
                  <blockquote className="veenadoc-philosophy-quote" style={{borderLeft: '4px solid #2e7d32', paddingLeft: '15px', fontStyle: 'italic', margin: '20px 0'}}>
                    "In my approach at H-Cura, I view oral health as integrated with overall wellness, emphasizing education and disease prevention to ensure my patients enjoy a lifetime of healthy smiles."
                  </blockquote>
                </div>

                {/* Services */}
                <div className="veenadoc-article-block">
                  <h2>Advanced Dental Services</h2>
                  <p>
                    Dr. Sharmila offers a comprehensive range of services tailored to meet the needs of the Chennai community:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li><strong>Preventive Dentistry:</strong> Advanced cleanings, sealants, and early detection of dental decay.</li>
                    <li><strong>Patient Education:</strong> Detailed guidance on maintaining optimal oral hygiene at home.</li>
                    <li><strong>General & Restorative Care:</strong> Precision fillings, gum health treatments, and root canal consultations.</li>
                    <li><strong>Holistic Dental Consultations:</strong> Analyzing the impact of oral health on systemic well-being.</li>
                  </ul>
                </div>

                {/* Why Choose */}
                <div className="veenadoc-article-block">
                  <h2>Why Choose Dr. Sharmila?</h2>
                  <p>
                    For residents searching for the <strong>best dentist in Chennai</strong> or a trusted <strong>family dental specialist</strong>, Dr. Sharmila at H-Cura provides a refreshing experience. She treats every consultation as an opportunity to build a lasting relationship based on trust and transparency. Her focus on the root cause of dental issues ensures that her patients achieve healthy smiles that last a lifetime.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose H-Cura for Your Dental Wellness</h2>
                  <p>
                    Whether you are looking for a routine check-up, a solution for tooth sensitivity, or a comprehensive oral health plan, Dr. Sharmila at <strong>H-Cura Multispeciality Clinic</strong> provides the expert care you deserve. Her proactive approach makes her a standout professional for patients who value quality and long-term health.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower patients in Chennai with healthier lives, stronger teeth, and renewed confidence through holistic dental care.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{fontSize: '14px'}}>
                      "Treating every patient with a holistic and preventive approach at H-Cura."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Sharmila's Philosophy</p>
                  </div>
                </div>

                {/* Practice Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Multispeciality Clinic</h4>
                      <p>Chennai, Tamil Nadu</p>
                      <p><small>Expert Dental Wing</small></p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience world-class dental care with Dr. Sharmila's personalized approach at H-Cura.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => navigate('/bookconsultation')}>
                    <span>💬</span>
                    <span>Online Booking</span>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Dr. Sharmila's Profile (PDF)
        </button>
      </div>
    </>
  )
}

export default SharmilaDoc;
